export const TOAST_WIDTH = '20rem'
